module.exports = "/static/media/loader.9d04a412.gif";